import type { DomainSchema, PdfCardDef } from '../types';
import { fmtDate, esc, metaJoin } from '../pdf-helpers';

export const COURSES = {
  priority: true,
  cardTitle: '{courseName}',
  fields: {
    courseName: { type: 'text', label: 'Course Name' },
    courseNumber: { type: 'text', label: 'Course Number' },
    provider: { type: 'text' },
    completedAt: { type: 'date', label: 'Completed' },
  },
  layout: [[{ field: 'provider' }, { field: 'courseNumber' }], [{ field: 'completedAt' }]],
  editLayout: [
    [{ field: 'courseName' }],
    [{ field: 'provider' }, { field: 'courseNumber' }],
    [{ field: 'completedAt' }],
  ],
} satisfies DomainSchema;

export const CoursesPdfCard: PdfCardDef = {
  styles: `
    .course-item { padding: 0.65rem 0; border-bottom: 1px solid var(--line); }
    .course-item:first-child { padding-top: 0; }
    .course-item:last-child { border-bottom: none; padding-bottom: 0; }
    .course-name { font-size: 13px; font-weight: 700; }
    .course-meta { font-size: 11px; color: var(--muted); margin-top: 2px; }
  `,
  render(records) {
    return records
      .map(r => {
        const meta = metaJoin([
          r['provider'] ? esc(r['provider']) : null,
          r['courseNumber'] ? esc(r['courseNumber']) : null,
          r['completedAt'] ? fmtDate(r['completedAt']) : null,
        ]);
        return `
          <div class="course-item">
            <div class="course-name">${esc(r['courseName'])}</div>
            ${meta ? `<div class="course-meta">${meta}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
